import { React } from 'react';
import { Shelf } from '../components';

export default function Caves() {
    return (
        <div className="caves">                      
            <Shelf shelfName="Caves" tableItemsPath="recode/caves/curios"/>
        </div>        
    )
};